/* unplugin-vue-components disabled */import { render } from "./c-banner.vue?vue&type=template&id=4cc1fe30&scoped=true"
import script from "./c-banner.vue?vue&type=script&lang=js"
export * from "./c-banner.vue?vue&type=script&lang=js"

import "./c-banner.vue?vue&type=style&index=0&id=4cc1fe30&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc1fe30"]])

export default __exports__